import React, { useState, useRef, useEffect } from "react";

export default function NoteCitations({ citationData = null, fullTranscript = null }) {
  const [hoveredSentenceId, setHoveredSentenceId] = useState(null);
  const transcriptContainerRef = useRef(null);

  // Function to scroll to highlighted transcript section
  const scrollToHighlightedSection = () => {
    if (!transcriptContainerRef.current || hoveredSentenceId === null) return;

    // Small delay to ensure the highlight has been applied
    setTimeout(() => {
      const highlightedElement = transcriptContainerRef.current.querySelector('#highlighted-transcript-chunk');
      
      if (highlightedElement) {
        const container = transcriptContainerRef.current;
        const containerRect = container.getBoundingClientRect();
        const elementRect = highlightedElement.getBoundingClientRect();
        
        // Calculate the scroll position to center the highlighted element
        const scrollTop = container.scrollTop + 
          (elementRect.top - containerRect.top) - 
          (containerRect.height / 2) + 
          (elementRect.height / 2);
        
        container.scrollTo({
          top: Math.max(0, scrollTop),
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  // Auto-scroll when hovering over a cited sentence
  useEffect(() => {
    scrollToHighlightedSection();
  }, [hoveredSentenceId]);

  // Use provided citation data or fallback to sample data
  const sample_data = {
    status: "success",
    timestamp: "cc0e2830-3191-4a5a-9250-3884d0593efb",
    input_metadata: {
      transcript_length: 1520,
      medical_note_length: 1349,
      transcript_chunks: 4,
      soap_sentences: 11,
    },
    citations: [
      {
        soap_sentence_id: 0,
        soap_sentence_text:
          "History of Present Illness: Juan presents today as a new patient to me. He has seen my partner, Dr. Halbrecht, in the past for this right knee",
        soap_sentence_position: { start: 0, end: 142 },
        similarity_score: 0.8038534376243158,
        is_cited: true,
        transcript_chunk_id: 0,
        transcript_chunk_text:
          "Juan presents today's a new patient to me. He has seen my partner, Dr. Halbrecht, in the past for this right knee. The patient is morbidly obese and has both osteoarthritis of this right knee as well as pretty extensive medial and lateral meniscal tears. He has been attempting conservative management. He is not a candidate due to his weight for a total joint replacement period. Because of this, they have been talking about a knee arthroscopy to debride both the medial and lateral meniscal tears",
        transcript_chunk_position: { start: 0, end: 499 },
      },
      {
        soap_sentence_id: 1,
        soap_sentence_text:
          ". Halbrecht, in the past for this right knee. The patient is morbidly obese and has both osteoarthritis of this right knee as well as pretty extensive medial and lateral meniscal tears",
        soap_sentence_position: { start: 142, end: 326 },
        similarity_score: 0.9075875774562021,
        is_cited: true,
        transcript_chunk_id: 0,
        transcript_chunk_text:
          "Juan presents today's a new patient to me. He has seen my partner, Dr. Halbrecht, in the past for this right knee. The patient is morbidly obese and has both osteoarthritis of this right knee as well as pretty extensive medial and lateral meniscal tears. He has been attempting conservative management. He is not a candidate due to his weight for a total joint replacement period. Because of this, they have been talking about a knee arthroscopy to debride both the medial and lateral meniscal tears",
        transcript_chunk_position: { start: 0, end: 499 },
      },
      {
        soap_sentence_id: 2,
        soap_sentence_text:
          ". He has been attempting conservative management. He is not a candidate due to his weight for a total joint replacement",
        soap_sentence_position: { start: 326, end: 445 },
        similarity_score: 0.6598372345189942,
        is_cited: true,
        transcript_chunk_id: 0,
        transcript_chunk_text:
          "Juan presents today's a new patient to me. He has seen my partner, Dr. Halbrecht, in the past for this right knee. The patient is morbidly obese and has both osteoarthritis of this right knee as well as pretty extensive medial and lateral meniscal tears. He has been attempting conservative management. He is not a candidate due to his weight for a total joint replacement period. Because of this, they have been talking about a knee arthroscopy to debride both the medial and lateral meniscal tears",
        transcript_chunk_position: { start: 0, end: 499 },
      },
      {
        soap_sentence_id: 3,
        soap_sentence_text:
          ". Because of this, they have been talking about a knee arthroscopy to debride both the medial and lateral meniscal tears. He comes in today to discuss proceeding with that intervention",
        soap_sentence_position: { start: 445, end: 629 },
        similarity_score: 0.8313588541226682,
        is_cited: true,
        transcript_chunk_id: 2,
        transcript_chunk_text:
          ". Dr. Halbrecht's with a history of Both media degenerative medial and lateral meniscal tears period plan for Him is To proceed with a medial lateral meniscal debridement We discussed this procedure at length today. We discussed how there is concern that he may not really make a full recovery due to the underlying osteoarthritis in his knee as well. But that being said, he has really failed extensive conservative management at this point without any significant improvement period",
        transcript_chunk_position: { start: 962, end: 1446 },
      },
      {
        soap_sentence_id: 4,
        soap_sentence_text:
          ". Physical Exam: Right knee exam: - 1+ knee effusion - Tenderness over the medial and lateral joint line - Pain with both medial and lateral McMurray Assessment/Plan:Juan is a new patient to me today,",
        soap_sentence_position: { start: 629, end: 829 },
        similarity_score: 0.8319767597442845,
        is_cited: true,
        transcript_chunk_id: 1,
        transcript_chunk_text:
          ". Period D comes in today to discuss proceeding with that intervention. Period new paragraph, right knee exam. Please see prior notes for full exam. But please insert a right knee exam. There's a one plus knee effusion, tenderness over the medial and lateral joint line, and pain with both medial and lateral McMurray. please insert review systems in general exam period new paragraph assessment and plan one is a New patient to me today patient of my partner. Dr",
        transcript_chunk_position: { start: 499, end: 962 },
      },
      {
        soap_sentence_id: 5,
        soap_sentence_text:
          "is a new patient to me today, a patient of my partner, Dr",
        soap_sentence_position: { start: 829, end: 886 },
        similarity_score: 0.575650717870471,
        is_cited: false,
      },
      {
        soap_sentence_id: 6,
        soap_sentence_text:
          ". Halbrecht, with a history of both degenerative medial and lateral meniscal tears. Plan for him is to proceed with a medial and lateral meniscal debridement",
        soap_sentence_position: { start: 886, end: 1043 },
        similarity_score: 0.907023680473485,
        is_cited: true,
        transcript_chunk_id: 2,
        transcript_chunk_text:
          ". Dr. Halbrecht's with a history of Both media degenerative medial and lateral meniscal tears period plan for Him is To proceed with a medial lateral meniscal debridement We discussed this procedure at length today. We discussed how there is concern that he may not really make a full recovery due to the underlying osteoarthritis in his knee as well. But that being said, he has really failed extensive conservative management at this point without any significant improvement period",
        transcript_chunk_position: { start: 962, end: 1446 },
      },
      {
        soap_sentence_id: 7,
        soap_sentence_text: ". We discussed this procedure at length today",
        soap_sentence_position: { start: 1043, end: 1088 },
        similarity_score: 0.47499935231196866,
        is_cited: false,
      },
      {
        soap_sentence_id: 8,
        soap_sentence_text:
          ". We discussed how there is concern that he may not really make a full recovery due to the underlying osteoarthritis in his knee as well, but that being said, he has really failed extensive",
        soap_sentence_position: { start: 1088, end: 1277 },
        similarity_score: 0.7373866692481252,
        is_cited: true,
        transcript_chunk_id: 0,
        transcript_chunk_text:
          "Juan presents today's a new patient to me. He has seen my partner, Dr. Halbrecht, in the past for this right knee. The patient is morbidly obese and has both osteoarthritis of this right knee as well as pretty extensive medial and lateral meniscal tears. He has been attempting conservative management. He is not a candidate due to his weight for a total joint replacement period. Because of this, they have been talking about a knee arthroscopy to debride both the medial and lateral meniscal tears",
        transcript_chunk_position: { start: 0, end: 499 },
      },
      {
        soap_sentence_id: 9,
        soap_sentence_text:
          "that being said, he has really failed extensive conservative management at this point without any significant improvement",
        soap_sentence_position: { start: 1277, end: 1398 },
        similarity_score: 0.5981528767169105,
        is_cited: false,
      },
      {
        soap_sentence_id: 10,
        soap_sentence_text:
          ". We will plan to see him back after surgical intervention is approved.",
        soap_sentence_position: { start: 1398, end: 1469 },
        similarity_score: 0.978932529648601,
        is_cited: true,
        transcript_chunk_id: 3,
        transcript_chunk_text:
          ". We will plan to see him back after surgical intervention is approved period.",
        transcript_chunk_position: { start: 1446, end: 1524 },
      },
    ],
    statistics: {
      total_sentences: 11,
      cited_sentences: 8,
      uncited_sentences: 3,
      average_similarity: 0.7551599717941841,
      max_similarity: 0.978932529648601,
      min_similarity: 0.47499935231196866,
    },
    configuration: {
      similarity_threshold: 0.6,
      embedding_model: "pubmedbert-base-embeddings-endpoint",
    },
  };

  // Handle loading state and data validation
  if (!citationData) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-center">
          <div className="text-lg font-medium text-gray-600 mb-2">
            Note Citations
          </div>
          <div className="text-sm text-gray-500">
            Citation data is being processed...
          </div>
        </div>
      </div>
    );
  }

  // Try to parse citationData if it's a string
  let parsedData;
  try {
    parsedData =
      typeof citationData === "string"
        ? JSON.parse(citationData)
        : citationData;
  } catch (error) {
    console.error("Error parsing citation data:", error);
    parsedData = sample_data; // fallback to sample data
  }

  const data = parsedData || sample_data;

  // Validate data structure
  if (
    !data.citations ||
    !Array.isArray(data.citations) ||
    data.citations.length === 0
  ) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-center">
          <div className="text-lg font-medium text-gray-600 mb-2">
            Note Citations
          </div>
          <div className="text-sm text-gray-500">
            No citation data available for this note.
          </div>
        </div>
      </div>
    );
  }

  // Build the complete transcript from chunks
  const buildTranscript = () => {
    // If we have the full transcript, use it directly
    if (fullTranscript) {
      return fullTranscript;
    }

    // Fallback to building from cited chunks (original behavior)
    const chunks = [];
    const seenChunkIds = new Set();

    data.citations.forEach((citation) => {
      if (
        citation.is_cited &&
        citation.transcript_chunk_id !== undefined &&
        citation.transcript_chunk_text &&
        !seenChunkIds.has(citation.transcript_chunk_id)
      ) {
        chunks.push({
          id: citation.transcript_chunk_id,
          text: citation.transcript_chunk_text,
          position: citation.transcript_chunk_position || { start: 0, end: 0 },
        });
        seenChunkIds.add(citation.transcript_chunk_id);
      }
    });

    // Sort chunks by position and join them
    return chunks
      .sort((a, b) => a.position.start - b.position.start)
      .map((chunk) => chunk.text)
      .join(" ");
  };

  // Render SOAP note with hoverable sentences
  const renderSoapNote = () => {
    const sortedCitations = [...data.citations]
      .filter(
        (citation) =>
          citation.soap_sentence_text && citation.soap_sentence_id !== undefined
      )
      .sort((a, b) => a.soap_sentence_id - b.soap_sentence_id);

    const elements = [];

    sortedCitations.forEach((citation, index) => {
      const text = citation.soap_sentence_text;

      // Check if this sentence starts a new SOAP section
      const isNewSection =
        /^(SUBJECTIVE:|OBJECTIVE:|ASSESSMENT:|PLAN:|History of Present Illness:|CC:|HPI:|Physical Exam:|Assessment\/Plan:)/i.test(
          text.trim()
        );

      // Add line breaks before new sections (except for the first element)
      if (isNewSection && index > 0) {
        elements.push(<br key={`br1-${citation.soap_sentence_id}`} />);
        elements.push(<br key={`br2-${citation.soap_sentence_id}`} />);
      }

      elements.push(
        <span
          key={citation.soap_sentence_id}
          className="inline"
          data-sentence-id={citation.soap_sentence_id}
          onMouseEnter={() => setHoveredSentenceId(citation.soap_sentence_id)}
          onMouseLeave={() => setHoveredSentenceId(null)}
          style={{
            backgroundColor:
              hoveredSentenceId === citation.soap_sentence_id &&
              citation.is_cited
                ? "rgba(34, 197, 94, 0.3)"
                : "transparent",
            cursor: citation.is_cited ? "pointer" : "default",
            transition: "background-color 0.2s ease-in-out",
            padding: "1px 2px",
            borderRadius: "2px",
            borderLeft: citation.is_cited ? "3px solid rgba(34, 197, 94, 0.4)" : "none",
            paddingLeft: citation.is_cited ? "6px" : "2px",
          }}
          title={citation.is_cited ? "Click to scroll to transcript section" : "Not cited in transcript"}
        >
          {text}
        </span>
      );
    });

    return elements;
  };

  // Get highlighted transcript
  const getHighlightedTranscript = () => {
    const fullTranscriptText = buildTranscript();

    if (hoveredSentenceId === null || !fullTranscriptText) {
      // Show message if no transcript data is available
      if (!fullTranscriptText) {
        return '<div class="text-gray-500 italic text-center p-4">No transcript data available</div>';
      }
      
      // Apply the same formatting as the original transcript tab
      return fullTranscriptText
        .replace(/\n/g, "<br>")
        .replace(/ {2}/g, "&nbsp;&nbsp;");
    }

    const hoveredCitation = data.citations.find(
      (c) => c.soap_sentence_id === hoveredSentenceId
    );
    if (
      !hoveredCitation ||
      !hoveredCitation.is_cited ||
      !hoveredCitation.transcript_chunk_text
    ) {
      return fullTranscriptText
        .replace(/\n/g, "<br>")
        .replace(/ {2}/g, "&nbsp;&nbsp;");
    }

    const chunkToHighlight = hoveredCitation.transcript_chunk_text;

    // Try to find and highlight the chunk in the full transcript
    if (fullTranscriptText.includes(chunkToHighlight)) {
      const highlighted = fullTranscriptText.replace(
        new RegExp(chunkToHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
        `<span id="highlighted-transcript-chunk" style="background-color: rgba(251, 191, 36, 0.3); padding: 2px 4px; border-radius: 3px; transition: background-color 0.2s ease-in-out; box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.1);">${chunkToHighlight}</span>`
      );
      return highlighted
        .replace(/\n/g, "<br>")
        .replace(/ {2}/g, "&nbsp;&nbsp;");
    }

    return fullTranscriptText
      .replace(/\n/g, "<br>")
      .replace(/ {2}/g, "&nbsp;&nbsp;");
  };

  const hoveredCitation =
    hoveredSentenceId !== null
      ? data.citations.find((c) => c.soap_sentence_id === hoveredSentenceId)
      : null;

  // Component for ring-style confidence display
  const ConfidenceRing = ({ confidence, isVisible }) => {
    const percentage = isVisible ? Math.round(confidence * 100) : 0;
    const degrees = (percentage / 100) * 360;

    return (
      <div className="flex justify-center mt-4">
        <div className="bg-white border border-gray-200 rounded-lg p-4 text-center shadow-md">
          <div className="relative w-16 h-16 mx-auto mb-3">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center relative transition-all duration-1000 ease-out"
              style={{
                background: `conic-gradient(#10b981 0deg ${degrees}deg, #e2e8f0 ${degrees}deg 360deg)`,
              }}
            >
              <div
                className="absolute w-11 h-11 bg-white rounded-full"
                style={{ zIndex: 1 }}
              />
              <div
                className="absolute text-sm font-bold text-gray-800 transition-all duration-500"
                style={{ zIndex: 2 }}
              >
                {isVisible ? `${percentage}%` : "N/A"}
              </div>
            </div>
          </div>
          <div className="text-gray-600 text-xs font-medium">
            Confidence Score
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="h-full">
      {/* Confidence Display - Always visible, animated ring */}
      {/* <ConfidenceRing
                confidence={hoveredCitation?.similarity_score || 0}
                isVisible={hoveredCitation && hoveredCitation.is_cited}
            /> */}

      {/* Main content area */}
      <div className="grid grid-cols-2 gap-4 h-full pt-5">
        {/* Visit Note Container */}
        <div className="flex flex-col h-full">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-accent1 text-xl font-bold">Visit Note</span>
            {/* <div className="flex items-center gap-4 text-xs">
                            <div className="flex items-center gap-1">
                                <div className="w-3 h-1 bg-green-500"></div>
                                <span className="text-gray-600">Cited</span>
                            </div>
                            <div className="flex items-center gap-1">
                                <div className="w-3 h-1 bg-red-500 opacity-70"></div>
                                <span className="text-gray-600">Not Cited</span>
                            </div>
                        </div> */}
          </div>
          <div
            className="form-control resize-none mb-4 mt-2 rounded-md border-0 shadow-knowtex-shadow bg-secondary-grey p-3 whitespace-pre-wrap overflow-y-auto"
            style={{
              fontSize: "14px",
              minHeight: "200px",
              maxHeight: "calc(100vh - 200px)",
            }}
          >
            <div
              style={{
                lineHeight: "1.625",
                fontSize: "14px",
              }}
            >
              {renderSoapNote()}
            </div>
          </div>
        </div>

        {/* Transcript Container */}
        <div className="flex flex-col h-full">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-accent1 text-xl font-bold">Transcript</span>
            {fullTranscript && (
              <span className="text-xs text-gray-500 bg-green-100 px-2 py-1 rounded">
                Full transcript
              </span>
            )}
          </div>
          <div
            ref={transcriptContainerRef}
            className="form-control resize-none mb-4 mt-2 rounded-md border-0 shadow-knowtex-shadow bg-secondary-grey p-3 whitespace-pre-wrap overflow-y-auto"
            style={{
              fontSize: "14px",
              minHeight: "200px",
              maxHeight: "calc(100vh - 200px)",
            }}
            dangerouslySetInnerHTML={{
              __html: getHighlightedTranscript(),
            }}
          />
        </div>
      </div>
    </div>
  );
}
